import React, { useEffect, useState, useRef } from "react";
import mqtt from "mqtt";

export default function WsReceiver() {
  const [messages, setMessages] = useState([]);
  const [status, setStatus] = useState("🔴 Disconnected");
  const clientRef = useRef(null);
  const endRef = useRef(null);
  const topic = "chao"; // phải trùng với topic server

  useEffect(() => {
    console.log("🧩 Khởi tạo MQTT WebSocket...");
    const client = mqtt.connect("ws://vip.tecom.pro:8793");
    clientRef.current = client;

    client.on("connect", () => {
      console.log("✅ MQTT WebSocket connected!");
      setStatus("🟢 Connected");

      client.subscribe(topic, (err) => {
        if (err) return console.error("❌ Subscribe failed:", err.message);
        console.log(`📡 Subscribed to ${topic}`);
      });
    });

    client.on("message", (t, msg) => {
      const now = new Date().toLocaleTimeString();
      const text = `[${now}] ${t}: ${msg.toString()}`;
      console.log("📩 Nhận MQTT:", text);
      setMessages((prev) => [...prev, text]);
    });

    client.on("error", (err) => {
      console.error("⚠️ MQTT error:", err.message);
      setStatus("⚠️ Error");
    });

    client.on("close", () => {
      console.log("🔴 MQTT WebSocket disconnected");
      setStatus("🔴 Disconnected");
    });

    return () => {
      console.log("🔌 Đóng MQTT client khi component unmount");
      client.end(true);
    };
  }, []);

  useEffect(() => {
    endRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  return (
    <div className="p-4 font-mono bg-gray-50 min-h-screen flex flex-col items-center">
      <div className="w-full max-w-2xl">
        <h2 className="font-bold text-lg mb-2 text-center">📡 MQTT Receiver (Debug)</h2>
        <div className="mb-3 text-sm text-center">
          Trạng thái: <span className="font-semibold">{status}</span>
        </div>
        <div className="bg-white shadow rounded-lg p-3 max-h-[70vh] overflow-y-auto border border-gray-200">
          {messages.length === 0 ? (
            <div className="text-gray-400 italic text-center">⏳ Chưa có tin nhắn...</div>
          ) : (
            <ul className="space-y-1">
              {messages.map((msg, i) => (
                <li key={i} className="break-all text-sm">{msg}</li>
              ))}
            </ul>
          )}
          <div ref={endRef} />
        </div>
      </div>
    </div>
  );
}
